<script setup lang="ts">
import useEventStore from "~/stores/event";

const { t } = useI18n();
const route = useRoute();
const eventStore = useEventStore();

const event = computed(() => eventStore.data);
const loading = computed(() => eventStore.loading);
const videoId = computed(() => route.params.eventId as string || undefined);

watch(
  () => [route.params.eventId, route.query.mediaId, route.query.type],
  ([eventId, mediaId, type]) => {
    if (mediaId)
      return eventStore.load(mediaId as string, type as TEventType);
    eventStore.reset();
    eventId && eventStore.load(eventId as string, type as TEventType);
  },
  { immediate: true },
);

useHead({ title: computed(() => event.value?.title as string) });
definePageMeta({ layout: "home" });
</script>

<template>
  <div class="main-container">
    <div v-if="loading" class="flex flex-col lg:flex-row mb-10 lg:gap-6">
      <div class="skeletonLoading aspect-video lg:w-2/3" />
      <div class="skeletonLoading lg:w-1/3" />
    </div>

    <div v-else class="flex flex-col lg:flex-row mb-10 lg:gap-6">
      <EventBlock class="lg:w-2/3" :event="event" />
      <EventTabs class="lg:w-1/3" :event="event" />
    </div>

    <ListEvents
      :title="t('pages.videos.user_interesting')"
      :event-id="videoId"
      class="text-2xl text-main"
      hide-on-no-content
      has-see-all-link
      suggested
      exclude-with-event-id
    />
  </div>
</template>
